/**
 * @desc 银联签约页面
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** @Min: 1.0 - @Max: null (until #1244 gets fixed) */
  detail: number
  /** orderNo */
  orderNo: string
  /** sign */
  sign: string
  /** token */
  token: string
}

export const init = undefined

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/unionBankSign',
    params,
    method: 'get',
  })
}
